import { html, paragraphs } from '../lib/html.js';
import { icon } from '../lib/icons.js';
import { person, loadVerse, getIndex } from '../lib/content.js';
import { topbar } from '../components/chrome.js';
import { verseRow } from '../components/verse.js';
import { plural } from '../lib/format.js';
import { deva } from './people.js';
import notfound from './notfound.js';

export default async function personView({ id }) {
  const p = person(id);
  if (!p) return notfound();
  const verses = await Promise.all(p.verses.map(async (vid) => ({ vid, v: await loadVerse(vid) })));
  const spoken = getIndex().speakerCounts[p.id] || 0;
  return {
    title: p.name,
    html: html`<div class="person">
      ${topbar({ back: '/people', title: p.name })}
      <header class="wrap page-head person__head">
        <span class="avatar avatar--xl${p.id === 'krishna' ? ' avatar--krishna' : ''}" aria-hidden="true">${deva(p)}</span>
        <div>
          <h1 class="h1">${p.name}</h1>
          <p class="person__sa"><span class="deva" lang="sa">${p.sa}</span> <span class="iast" lang="sa-Latn">${p.iast}</span></p>
          <p class="person__role">${p.role}</p>
        </div>
      </header>
      <div class="wrap">
        <p class="lede">${p.short}</p>
        ${spoken ? html`<p class="person__spoken">${icon('quote', { size: 16 })} Speaks ${plural(spoken, 'verse')} of the Gita</p>` : ''}
        <div class="prose person__body">${paragraphs(p.body)}</div>
        ${p.epithets && p.epithets.length ? html`<section class="section" aria-labelledby="names-title">
          <h2 class="h3" id="names-title">Other names you will see</h2>
          <p class="small muted" style="margin:4px 0 12px">The Gita often calls ${p.name} by these names. Each one means something.</p>
          <dl class="epithets">${p.epithets.map((e) => html`<div><dt>${e.name}</dt><dd>${e.meaning}</dd></div>`)}</dl>
        </section>` : ''}
        ${p.relations.length ? html`<section class="section" aria-labelledby="rel-title">
          <h2 class="h3" id="rel-title" style="margin-bottom:12px">Connections</h2>
          <ul class="list">${p.relations.map((r) => {
            const o = person(r.id);
            return o ? html`<li><a class="list__item" href="/person/${o.id}">
              <span class="avatar${o.id === 'krishna' ? ' avatar--krishna' : ''}" aria-hidden="true">${deva(o)}</span>
              <span class="list__body"><span class="list__title">${o.name}</span><span class="list__sub">${r.label}</span></span>
              <span class="list__trail">${icon('chevron-right', { size: 18 })}</span></a></li>` : '';
          })}</ul>
        </section>` : ''}
        ${verses.length ? html`<section class="section" aria-labelledby="pv-title">
          <h2 class="h3" id="pv-title" style="margin-bottom:12px">Where to find ${p.name}</h2>
          <div class="verse-rows">${verses.filter((x) => x.v).map(({ vid, v }) => verseRow(Number(vid.split('.')[0]), v))}</div>
        </section>` : ''}
      </div>
    </div>`,
  };
}
